import { Skeleton } from '../../../Skeleton'

import { ENTITY_PHASE_LIST_LOADING_ITEMS_COUNT } from './EntityPhaseListLoading.constants'

import * as styles from './EntityPhaseListLoading.module.css'

import PhaseArrowBackIcon from '../../../../icons/phase-arrow-back.svg'
import PhaseArrowFrontIcon from '../../../../icons/phase-arrow-front.svg'

function EntityPhaseListLoading({
  className = styles.EntityPhaseListLoading,
  itemsCount = ENTITY_PHASE_LIST_LOADING_ITEMS_COUNT,
}) {
  return (
    <div className={className}>
      {Array.from({ length: itemsCount }).map((_, index) => (
        <div className={styles.item} key={index}>
          {index > 0 ? (
            <PhaseArrowBackIcon className={styles.backPart} />
          ) : null}
          <Skeleton className={styles.body} />
          {index < itemsCount - 1 ? (
            <PhaseArrowFrontIcon className={styles.frontPart} />
          ) : null}
        </div>
      ))}
    </div>
  )
}

export default EntityPhaseListLoading
